import { ApiEndpoints } from '@/types/routes';
import { IHttpClient } from '@/api/HttpClient';
import { IDocumentationApi, IGetDocTokenResponse } from '@/api/documentation/documentation.types';

export class DocumentationApi implements IDocumentationApi {
  private getBaseUrl(): string {
    return ApiEndpoints.DOCUMENTATION;
  }

  constructor(private readonly httpClient: IHttpClient) {}

  getApiTutorialDocToken() {
    return this.httpClient.post<Record<string, never>, IGetDocTokenResponse>(
      `${this.getBaseUrl()}api-tutorial/token`,
      {},
    );
  }
}
